import { TableColumn } from './BillingTableHeading'

export const getSpentColumns = (t): TableColumn[] => [
    { id: 'request', label: t('finances.request'), maxWidth: 200 },
    { id: 'status', label: t('finances.status'), maxWidth: 200 },
    { id: 'date', label: t('finances.date'), maxWidth: 200, align: 'right' },
    {
        id: 'price',
        label: t('finances.amount'),
        maxWidth: 200,
        align: 'right',
    },
]

export const getSpentMobileColumns = (t): TableColumn[] => [
    { id: 'title', label: t('finances.request'), maxWidth: 100 },
    { id: 'date', label: t('finances.date'), maxWidth: 80, align: 'right' },
    {
        id: 'price',
        label: t('finances.amount'),
        maxWidth: 100,
        align: 'right',
    },
]

export const getAddColumns = (t): TableColumn[] => [
    { id: 'add', label: t('finances.type'), maxWidth: 100 },
    { id: 'status', label: t('finances.status'), maxWidth: 80, align: 'right' },
    { id: 'date', label: t('finances.date'), maxWidth: 80, align: 'right' },
    {
        id: 'price',
        label: t('finances.amount'),
        maxWidth: 100,
        align: 'right',
    },
]

export enum BillingType {
    Spent = 'spent',
    Add = 'add',
}
